import type { ReactNode } from 'react'

interface SectionProps {
  children: ReactNode
  className?: string
  id?: string
  'data-testid'?: string
  variant?: 'default' | 'accent' | 'light' | 'dark'
}

export function Section({
  children,
  className = '',
  id,
  'data-testid': testId,
  variant = 'default'
}: SectionProps) {
  const variantClasses = {
    default: 'bg-white',
    accent: 'bg-accent-50',
    light: 'bg-neutral-50',
    dark: 'bg-neutral-800 text-white'
  }

  return (
    <section
      id={id}
      className={`py-16 px-4 md:px-8 lg:px-16 ${variantClasses[variant]} ${className}`}
      data-testid={testId}
    >
      <div className="max-w-6xl mx-auto">
        {children}
      </div>
    </section>
  )
}